/**
 * Formatting utilities for safe numeric display
 */

/**
 * Safely format a number to fixed decimal places
 * @param {*} val - Value to format (can be number, string, null, undefined)
 * @param {number} digits - Number of decimal places (default: 1)
 * @param {string} fallback - Fallback value if not a valid number (default: '0.0')
 * @returns {string} Formatted number string
 */
export const safeFixed = (val, digits = 1, fallback = '0.0') => {
  const n = Number(val);
  return Number.isFinite(n) ? n.toFixed(digits) : fallback;
};

/**
 * Safely format a currency value
 * @param {*} val - Value to format
 * @param {string} fallback - Fallback value (default: '$0.00')
 * @returns {string} Formatted currency string
 */
export const safeCurrency = (val, fallback = '$0.00') => {
  const n = Number(val);
  return Number.isFinite(n) ? `$${n.toFixed(2)}` : fallback;
};

/**
 * Safely format a percentage
 * @param {*} val - Value to format (0-100)
 * @param {number} digits - Decimal places (default: 0)
 * @param {string} fallback - Fallback value (default: '0%')
 * @returns {string} Formatted percentage string
 */
export const safePercent = (val, digits = 0, fallback = '0%') => {
  const n = Number(val);
  return Number.isFinite(n) ? `${n.toFixed(digits)}%` : fallback;
};

/**
 * Safely get a numeric value with default
 * @param {*} val - Value to coerce
 * @param {number} fallback - Fallback number (default: 0)
 * @returns {number} Valid number
 */
export const safeNumber = (val, fallback = 0) => {
  const n = Number(val);
  return Number.isFinite(n) ? n : fallback;
};
